import { Team, WebSocketAction, WebSocketEntityType } from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createTeamMessageHandler(eventEmitter: IEventEmitter) {
  return (action: WebSocketAction, item: Team) => {
    try {
      switch (action) {
        case WebSocketAction.INSERT:
          log.debug(`[TeamHandler] INSERT Team ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.Team,
            WebSocketEventType.INSERT,
            item,
          );
          break;
        case WebSocketAction.MODIFY:
          log.debug(`[TeamHandler] MODIFY Team ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.Team,
            WebSocketEventType.MODIFY,
            item,
          );
          break;
        case WebSocketAction.REMOVE:
          log.debug(`[TeamHandler] REMOVE Team ${item.id}`);
          eventEmitter.emit(
            WebSocketEntityType.Team,
            WebSocketEventType.REMOVE,
            item,
          );
          break;
        default:
          log.warn('[TeamHandler] Unknown action for Team:', action);
      }
    } catch (error) {
      log.error('[TeamHandler] Handler failed:', error);
    }
  };
}
